import React, { Component } from 'react';
import { FormicaProps, withFormica } from '../../../../helpers/withFormica';
import { RootState } from '../../../../redux/store';
import { AiModelState } from '../../../../redux/reducers/AiModelReducer';
import { changeAiModel } from '../../../../redux/actions/AiModelActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import CustomTable from '../../../custom/CustomTable';
import { ColumnProps } from 'primereact/column';
import { customConfirm } from '../../../custom/CustomPopupConfirm';
import LanguageUtil from '../../../../util/LanguageUtil';
import ComponentName from '../../../../constant/ComponentName';
import { Tooltip } from 'primereact/tooltip';
import Icon from '../../../../icons/Icon';
import AiModelCustomFeatureExpressionComponent from './AiModelCustomFeatureExpressionComponent';
import DataType from '../../../../constant/DataType';
import { DateVariableProperties } from '../../../../domain/datatype/VariablePropertiesDomains';
import CustomInput from '../../../custom/CustomInput';
import { MLOpsModelCustomFeature } from '../../../../domain/mlops/MLOpsDomains';
import EmptyListComponent from '../../../custom/empty-components/EmptyListComponent';

class AiModelCustomFeaturesComponent extends Component<Props> {
  public render() {
    const {
      aiModel: { aiModel },
    } = this.props;
    if (!aiModel.customFeatures || aiModel.customFeatures?.length <= 0) {
      return <EmptyListComponent />;
    }
    return <CustomTable columns={this.getColumns()} value={aiModel.customFeatures} />;
  }

  private getColumns = (): ColumnProps[] => {
    const {
      aiModel: { aiModel },
    } = this.props;
    return [
      {
        field: 'name',
        header: LanguageUtil.get({ id: 'pages.ai.editor.features.customFeatures.table.name', defaultMessage: 'Name' }),
        columnKey: 'name',
        className: 'min-w-[20%]',
        body: (rowData: MLOpsModelCustomFeature) => {
          return (
            <CustomInput
              inputType={'ghost'}
              type={'text'}
              onChange={(e) => this.onChangeVariableName(e, rowData)}
              value={rowData.name}
              data-testid={`${ComponentName.AI_MODEL}_variable_list_name_input`}
            />
          );
        },
      },
      {
        field: 'expression',
        header: LanguageUtil.get({ id: 'pages.ai.editor.features.customFeatures.table.expression', defaultMessage: 'Expression' }),
        columnKey: 'expression',
        className: 'min-w-[70%] overflow-x-scroll',
        body: (rowData: MLOpsModelCustomFeature) => {
          const { update, disabled } = this.props;
          let properties = rowData.properties;
          if (rowData.properties.dataType === DataType.DATE) {
            properties = { dataType: DataType.NUMBER } as DateVariableProperties;
          }
          return (
            <AiModelCustomFeatureExpressionComponent
              feature={rowData}
              aiModel={aiModel}
              onChange={this.onChangeRowData}
              returnType={properties}
              update={update}
              disabled={disabled}
            />
          );
        },
      },
      {
        field: 'action',
        header: LanguageUtil.get({ id: 'pages.ai.editor.features.customFeatures.table.action', defaultMessage: 'Action' }),
        className: 'max-w-[75px] 2xl:max-w-[100px]',
        body: (rowData: MLOpsModelCustomFeature) => {
          return (
            <div
              key='remove'
              onClick={(e: any) => {
                e.stopPropagation();
                e.preventDefault();
                customConfirm({
                  target: e.currentTarget,
                  accept: () => this.remove(rowData),
                  message: LanguageUtil.get({ id: 'messages.confirm.confirmRemove', defaultMessage: 'Are you sure you want to remove?' }),
                });
              }}
              data-testid={`${ComponentName.AI_MODEL}_remove_button`}
            >
              <Tooltip position={'left'} target={'.remove'}>
                {LanguageUtil.get({ id: 'common.label.remove', defaultMessage: 'Remove' })}
              </Tooltip>
              <Icon
                icon={'delete'}
                size={16}
                color={'primary'}
                className={'remove hover:text-primary text-f-black-4 hover:cursor-pointer flex items-center justify-center'}
              />
            </div>
          );
        },
      },
    ];
  };

  private remove = (rowData: MLOpsModelCustomFeature) => {
    const {
      aiModel: { aiModel },
    } = this.props;
    const index = aiModel.customFeatures.indexOf(rowData);
    if (index != -1) {
      aiModel.customFeatures.splice(index, 1);
      this.onChangeRowData();
    }
  };

  private onChangeRowData = () => {
    const {
      aiModel: { aiModel },
      changeAiModel,
    } = this.props;
    changeAiModel(aiModel);
  };

  private onChangeVariableName = (e: React.FormEvent<HTMLInputElement>, rowData: MLOpsModelCustomFeature) => {
    rowData.name = e.currentTarget.value;
    this.onChangeRowData();
  };
}

interface Props extends ReduxProps, FormicaProps {
  update: number;
  disabled: boolean;
}

const mapStateToProps = (state: RootState) => ({
  aiModel: state.aiModel as AiModelState,
  isUpdate: state.aiModel.isUpdate,
});
const mapDispatchToProps = {
  changeAiModel,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(AiModelCustomFeaturesComponent));
